import {
  type NoticeBadge,
  type NoticeMentorshipSignals,
  resolveNoticeBadge,
} from "./notice-badge";

// Fallback for channels without a matching mentorship (non-mentor viewers,
// support channels).
export const DEFAULT_MENTORSHIP_SIGNALS: NoticeMentorshipSignals = {
  birthday: false,
  momentHubKind: null,
  dayState: null,
  momentum: false,
  opportunityActivityKind: null,
  checkIn: false,
  opportunityHub: false,
  riskOfPause: false,
};

export interface ResolvedNoticeBadge {
  checkIn: boolean;
  badge: NoticeBadge | null;
}

// ORs the FE-local Sendbird check-in with the backend `check_in_due` so either
// source can raise the check-in badge.
export function resolveNoticeBadgeSignals(
  feCheckIn: boolean,
  mentorship?: NoticeMentorshipSignals,
  needsResponse = false,
): ResolvedNoticeBadge {
  const signals = mentorship ?? DEFAULT_MENTORSHIP_SIGNALS;
  const checkIn = feCheckIn || signals.checkIn;
  return {
    checkIn,
    badge: resolveNoticeBadge({
      ...signals,
      checkIn,
      needsResponse,
    }),
  };
}
